export default {
  title: "基础信息",
  caseType: "案件类型",
  creator: "创建人",
  createTime: "创建时间",
  updateTime: "更新时间",
  description: "案件说明",
};
